import { protectedDelete, protectedGet, protectedPatch, protectedPost } from "./restUtil";
import * as _ from "underscore";

const PREVIOUS_SEARCH_NAME = "Talaera_dictionary_search";
const PREVIOUS_SEARCH_NUMBER_OF_ITEMS = 5;

export function dictionarySearch(text, onSuccess, onError) {
  return protectedGet(
    "/dictionary/search",
    "text=" + encodeURIComponent(text),
    onSuccess,
    onError
  );
}

export function getPersonalDictionary(pagination, onSuccess, onError) {
  return protectedGet("/dictionary/saved", pagination, onSuccess, onError);
}

export function addWordToDictionary(data, onSuccess, onError) {
  return protectedPost("/dictionary/saved", data, onSuccess, onError);
}

export function updateDictionary(id, data, onSuccess, onError) {
  return protectedPatch(`/dictionary/saved/${id}`, data, onSuccess, onError);
}

export function getDictionaryExamples(data) {
  return new Promise((resolve, reject) => {
    protectedGet("/dictionary/examples", data, resolve, reject, {
      returnResponse: true,
      includeStatusCode: true,
    });
  });
}

export function deleteWordFromDictionary(id, onSuccess, onError) {
  return protectedDelete(`/dictionary/saved/${id}`, null, onSuccess, onError);
}

export function generateAIExercises(count) {
  return new Promise((resolve, reject) => {
    protectedPost("/ai/exercises", { count }, resolve, reject, {
      returnResponse: true,
      includeStatusCode: true,
    });
  });
}

export function answerToExercise(exerciseId, answers, onSuccess, onError) {
  return protectedPost(`/ai/exercise/${exerciseId}/answer`, answers, onSuccess, onError);
}

export function addItemToPreviousSearch(item) {
  let previousSearch = getPreviousSearch();

  if (previousSearch.indexOf(item) > -1) {
    // Don't add duplications.
    return previousSearch;
  }

  previousSearch.push(item);
  if (previousSearch.length > PREVIOUS_SEARCH_NUMBER_OF_ITEMS) {
    previousSearch = _.rest(
      previousSearch,
      previousSearch.length - PREVIOUS_SEARCH_NUMBER_OF_ITEMS
    );
  }

  localStorage.setItem(PREVIOUS_SEARCH_NAME, JSON.stringify(previousSearch));
  return previousSearch;
}

export function getPreviousSearch() {
  const previousSearch = localStorage.getItem(PREVIOUS_SEARCH_NAME);
  return previousSearch ? JSON.parse(previousSearch) : [];
}
